import Vue from 'vue'

Vue.component('plp-select', {
  props: [
    'name',
    'value',
    'id'
  ],
  data: function () {
    return {}
  },
  computed: {
    inputValue () {
      return this.sort
    }
  },
  methods: {
    updateSort (e) {
      this.$store
        .dispatch('updateSort', e.target.value)
        .then(() => {
          this.$store.dispatch('fetchCollection', {
            ajaxing: true,
            initial: false,
            resetSelectedFacets: false
          })
        })
    }
  },
  template: `
  <div class="plp-select select-input__wrapper">
    <select class="plp-select__el p1 select-input__el" :id="id" :name="name" :value="value" v-on:change="updateSort">
      <slot></slot>
    </select>
    <span class="select-input__icon icon">
      <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 11 6"><path fill="#0F3DFB" d="M5.4 5.7.7 1.4l.6-.8 4.1 3.7L9.7.6l.6.8z"></path></svg>
    </span>
  </div>`
})
